<template>
  <div id="app" class="app">
    <AppLayout v-if="!isScoringPage">
      <router-view></router-view>
    </AppLayout>
    <router-view v-else></router-view>
    
    <GlobalLoadingOverlay />
  </div>
</template>


<script>
import AppLayout from './components/AppLayout.vue';
import GlobalLoadingOverlay from './components/GlobalLoadingOverlay.vue';

export default {
  name: 'App',
  components: {
    AppLayout,
    GlobalLoadingOverlay
  },
  computed: {
    isScoringPage() {
      return this.$route.path.startsWith('/scoring');
    }
  },
  mounted() {
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      sessionStorage.setItem('refreshed', 'true');
    }
  },
};
</script>

<style>
.app {
  max-width: 1200px;
  margin: auto;
}
</style>